import React from 'react'

import SimpleTable from 'components_new/molecules/SimpleTable'

import { COGNITO_BASE_URL } from 'App/Auth/AuthModule'

const RELAY_SATE =
  process.env.NODE_ENV === 'development'
    ? 'http://localhost:3000'
    : 'https://portal.homepal.se'

const SettingsTable = () => {
  return (
    <>
      <SimpleTable
        border={true}
        columns={[{ align: 'left' }, { align: 'right' }]}
        rows={[
          { cells: [
            <React.Fragment key={0}>
              <b>Identifier (Entity ID)</b>
            </React.Fragment>,
            <React.Fragment key={1}>
              urn:amazon:cognito:sp:{process.env.REACT_APP_USER_POOL_ID}
            </React.Fragment>
          ] },
          { cells: [
            <React.Fragment key={0}>
              <b>Reply URL</b>
            </React.Fragment>,
            <React.Fragment key={1}>
              {COGNITO_BASE_URL}/saml2/idpresponse
            </React.Fragment>
          ] },
          { cells: [
            <React.Fragment key={0}>
              <b>Relay State</b>
            </React.Fragment>,
            <React.Fragment key={1}>{RELAY_SATE}</React.Fragment>
          ] }
        ]}
        size="medium"
      />
    </>
  )
}

export default SettingsTable
